/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ServiceContactIndividualType } from './ServiceContactIndividualType';
import {
	ServiceContactIndividualTypeFromJSON,
	ServiceContactIndividualTypeFromJSONTyped,
	ServiceContactIndividualTypeToJSON,
} from './ServiceContactIndividualType';

/**
 * A payload that will add multiple service contacts to a multiple client organizations.
 * @export
 * @interface AddServiceContactsForMultipleClients
 */
export interface AddServiceContactsForMultipleClients {
	/**
	 *
	 * @type {ServiceContactIndividualType}
	 * @memberof AddServiceContactsForMultipleClients
	 */
	contactType?: ServiceContactIndividualType;
	/**
	 * The RIDs of the clients to add service contacts to
	 * @type {Array<string>}
	 * @memberof AddServiceContactsForMultipleClients
	 */
	clientRIDs?: Array<string>;
	/**
	 * The RIDs of the actors to add as service contacts
	 * @type {Array<string>}
	 * @memberof AddServiceContactsForMultipleClients
	 */
	actorRIDs?: Array<string>;
}

/**
 * Check if a given object implements the AddServiceContactsForMultipleClients interface.
 */
export function instanceOfAddServiceContactsForMultipleClients(value: object): boolean {
	let isInstance = true;

	return isInstance;
}

export function AddServiceContactsForMultipleClientsFromJSON(
	json: any
): AddServiceContactsForMultipleClients {
	return AddServiceContactsForMultipleClientsFromJSONTyped(json, false);
}

export function AddServiceContactsForMultipleClientsFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): AddServiceContactsForMultipleClients {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		contactType: !exists(json, 'contactType')
			? undefined
			: ServiceContactIndividualTypeFromJSON(json['contactType']),
		clientRIDs: !exists(json, 'clientRIDs') ? undefined : json['clientRIDs'],
		actorRIDs: !exists(json, 'actorRIDs') ? undefined : json['actorRIDs'],
	};
}

export function AddServiceContactsForMultipleClientsToJSON(
	value?: AddServiceContactsForMultipleClients | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		contactType: ServiceContactIndividualTypeToJSON(value.contactType),
		clientRIDs: value.clientRIDs,
		actorRIDs: value.actorRIDs,
	};
}
